<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import T from './CompanyProfileAvailableJobsSection.i18n.js';
import DsLinkBlock from 'JIX/components/ds/DsLinkBlock.vue';

const emit = defineEmits(['jobTab']);

const store = useStore();

const jobsContent = computed(() => store.state.jobsContent);

const jobsPrograms = computed(()=> {
    let jobs = JSON.parse(JSON.stringify(store.state.leftboxContent.programsInfo));
    if (jobsContent.value.noJobs) {
        jobs.unshift({ name: 'JOBS', url: store.state.urls.JOBS, count: jobsContent.value.noJobs });
    }

    return jobs;
});

function jobClicked(event, type) {
    let label;
    if (type === 'JOBS') {
        event.preventDefault();
        label = 'se-jobannoncer';
    } else if (type === 'TRAINEE') {
        label = 'se-elevpladser';
    } else if (type === 'GRADUATE') {
        label = 'se-graduate-programmer';
    }

    store.dispatch('jixAnalytics', { label, action: 'klik-venstre-navigation' });

    if (type === 'JOBS') {
        emit('jobTab');
    }
}
</script>

<template>
    <div>
        <template
            v-for="(type, index) in jobsPrograms"
            :key="index"
        >
            <div class="mb-3 bg-surface-default border">
                <div class="text-brand text-center display-4 mt-2">
                    {{ type.count }}
                </div>
                <div class="mb-2 text-center align-middle">
                    {{ T.typeText(type.name) }}
                </div>
                <hr class="m-0">
                <DsLinkBlock
                    :href="type.url"
                    @click="jobClicked($event, type.name)"
                    :link-class="'justify-content-center py-2 w-100 text-sm'"
                >
                    {{ T.linkText(type.name) }}
                </DsLinkBlock>
            </div>
        </template>
    </div>
</template>
